import { UserService } from '@fnv-core/authentication';
import { API_PREFIX } from './constants';
import { IApiOptions } from './interfaces';

export class UrlBuilder {
  
  static buildUrl(uri: string, options?: IApiOptions) {
    const opts = options || {};
    const urlParts: string[] = [];
    let urlPath = uri;

    if (uri.startsWith(`${API_PREFIX}/`)) {
      urlParts.push(API_PREFIX);
      // Everything after API_PREFIX/
      urlPath = uri.substring(API_PREFIX.length + 1);
    } else if (opts.useApiPrefix) {
      urlParts.push(API_PREFIX);
    }

    // Replace the {userId} in the url with the current user's id
    if (opts.injectUserId) {
      const userId = UserService.getUserId();
      urlPath = urlPath.replace('{userId}', userId);
    }

    urlParts.push(urlPath);

    return urlParts.join('/');
  }
}
